<template>
  <JobsProvider>
    <Toast position="top-right" />
    <ConfirmDialog />
    <router-view />
  </JobsProvider>
</template>

<script>
import JobsProvider from './components/JobsProvider'

export default {
  components: {
    JobsProvider,
  },
}
</script>
